import { ArrowDown2 } from "iconsax-react";

interface FilterButtonProps {
  label: string;
  onClick?: () => void;
}

export const FilterButton = ({ label, onClick }: FilterButtonProps) => (
  <button
    onClick={onClick}
    className="flex items-center text-sm gap-1 px-1.5 py-1 bg-dark-10 border border-dark-20 rounded-[5px] text-dark-text hover:border-dark-60 transition-colors"
  >
    <span>{label}</span>
    <ArrowDown2 color="#FEFEFE" className="w-3.5 h-3.5" />
  </button>
);
